/** True when `value` is a non-empty trimmed unsigned integer (typical PH# / MH#). */
export function isGeoItemNumericId(value: string | number | undefined | null): boolean {
  if (value === undefined || value === null) return false;
  return /^\d+$/.test(String(value).trim());
}

/**
 * Dialog title for a pothole / manhole: prepend `#` only for numeric ids.
 * Non-numeric ids are shown as-is; missing/blank falls back to `emptyLabel`.
 */
export function formatGeoItemDialogTitle(
  kind: 'Pothole' | 'Manhole',
  itemNumber: string | number | undefined | null,
  emptyLabel: string,
): string {
  const trimmed = itemNumber === undefined || itemNumber === null ? '' : String(itemNumber).trim();
  if (!trimmed) return `${kind} ${emptyLabel}`;
  return isGeoItemNumericId(trimmed) ? `${kind} #${trimmed}` : `${kind} ${trimmed}`;
}

/**
 * PH/MH reference for PDF headers and similar (`PH#12` vs `PH MH-3`).
 * Blank falls back to the bare field prefix with `#` (`PH#` / `MH#`).
 */
export function formatGeoItemNumberRef(prefix: 'PH' | 'MH', value: string | number | undefined | null): string {
  const trimmed = value === undefined || value === null ? '' : String(value).trim();
  if (!trimmed) return `${prefix}#`;
  return isGeoItemNumericId(trimmed) ? `${prefix}#${trimmed}` : `${prefix} ${trimmed}`;
}

/**
 * Leading `#` only when numeric (e.g. `Manhole Details: #12` vs `Manhole Details: MH-3`).
 * Blank returns an empty string.
 */
export function formatGeoItemOptionalHashId(value: string | number | undefined | null): string {
  const trimmed = value === undefined || value === null ? '' : String(value).trim();
  if (!trimmed) return '';
  return isGeoItemNumericId(trimmed) ? `#${trimmed}` : trimmed;
}
